import { render, staticRenderFns } from "./DataListPagination.vue?vue&type=template&id=48a857b1&scoped=true&"
import script from "./DataListPagination.vue?vue&type=script&lang=js&"
export * from "./DataListPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a857b1",
  null
  
)

export default component.exports